import { OptionDropdown, ItemOption } from '../models/event-content.model';

export function nommalizeLabels(
  evaluations: OptionDropdown[]
): OptionDropdown[] {
  return evaluations.map((evaluation) => normalizeLabelsEvaluation(evaluation));
}

function normalizeLabelsEvaluation(evaluation: OptionDropdown): OptionDropdown {
  return {
    ...evaluation,
    label: evaluation.label.toUpperCase(),
    items: normalizeLabelsItemsOption(evaluation.items),
  };
}

function normalizeLabelsItemsOption(items: ItemOption[]): ItemOption[] {
  return items.map((item) => normalizeLabelsItemOption(item));
}

function normalizeLabelsItemOption(item: ItemOption): ItemOption {
  return {
    ...item,
    label: capitalizeWords(item.label.toLowerCase()),
  };
}

function capitalizeWords(str: string): string {
  return str
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function normalizeArrayEvaluations(
  evaluations: OptionDropdown[],
  active: boolean
) {
  if (!validateEvaluations(evaluations)) {
    return evaluations;
  }
  if (active) {
    return evaluations[0].items;
  }
  return evaluations;
}

function validateEvaluations(evaluations: OptionDropdown[]): boolean {
  if (!evaluations) {
    return false;
  }
  if (evaluations === undefined) {
    return false;
  }
  if (evaluations.length === 0) {
    return false;
  }
  return true;
}
